import axios from "axios";

const toApi = async (
	options: {
		url: string,
		method: "GET" | "POST" | "PUT" | "DELETE",
		params?: Record<string, string>,
		token?: string,
		data?: any
	}
) => {
    try {
		const { url, method, params, token, data } = options;
        const response = await axios({
            method,
            url: `https://pheb7g2ne.steiner-consulting.eu/${url}`,
			headers: {
				'Content-Type': 'application/json',
				'Accept': '*/*',
				'Cache-Control': 'no-cache',
				...(token && { 'Authorization': `Bearer ${token}` }),
			},
			params: {
				...(params && { ...params }),
			},
			...(data && { data }),
        });
        return response.data;
    } catch (error: any) {
        console.error(error);
		if ("response" in error && "data" in error.response) return error.response.data;
    }
}

export const Request = {
	toApi,
};
